import React from "react";
import Block3 from "../Block3";
import SubHeading from "../SubHeading";

function MakeItModern() {
  return (
    <>
      {/* BLOCK */}
      <div className="p-4 md:p-0 mb-6">
        <SubHeading text="make it modern" color="black" />

        <div className="flex flex-col md:flex-row flex-wrap pt-5">
          <div className="w-full md:w-1/2 p-2.5">
            <Block3 />
          </div>
          <div className="w-full md:w-1/2 p-2.5">
            <Block3 />
          </div>
          <div className="w-full md:w-1/2 p-2.5">
            <Block3 />
          </div>
          <div className="w-full md:w-1/2 p-2.5">
            <Block3 />
          </div>
          <div className="w-full md:w-1/2 p-2.5">
            <Block3 />
          </div>
          <div className="w-full md:w-1/2 p-2.5">
            <Block3 />
          </div>
        </div>
      </div>
    </>
  );
}

export default MakeItModern;
